import { allow } from '../classes/allow';
import getDateStringFromObject from '../functions/get.date.string.from.object';
import { stripInvalidMbiChars } from '../functions/strip.invalid.mbi.chars';
import is from '../objects/is';
import dateFieldValue from '../objects/models/date.field.value';
import the from '../objects/the';
import use from '../objects/use';
import useAxios from './use.axios';

export default function useUnlockAccountApi() {
    const axios = useAxios();
    const data = use.unlockAccountData!;

    const step1 = async (mbi = '', effectiveDate = dateFieldValue, effectiveDatePart = '') => {
        allow.aString(mbi, is.not.empty).anInstanceOf(effectiveDate, dateFieldValue).oneOf(effectiveDatePart, the.part);
        data.coverageStartDate.set(effectiveDate);
        data.medicareNumber.set(mbi);
        data.part.set(effectiveDatePart);
        return await axios.call(
            the.method.post,
            '/account/api/unlock-account/step/1',
            {
                effectiveDate: getDateStringFromObject(data.coverageStartDate.get()),
                effectiveDatePart: data.part.get().toLowerCase(),
                mbi: stripInvalidMbiChars(data.medicareNumber.get()),
            },
            the.defaultHeader,
        );
    };

    const step2 = async (lastName = '', dateOfBirth = dateFieldValue, zipCodeOrCity = '') => {
        allow.aString(lastName, is.not.empty).anInstanceOf(dateOfBirth, dateFieldValue).aString(zipCodeOrCity, is.not.empty);
        data.lastName.set(lastName);
        data.dateOfBirth.set(dateOfBirth);
        data.zipCodeOrCity.set(zipCodeOrCity);
        return await axios.call(
            the.method.post,
            '/account/api/unlock-account/step/2',
            {
                dateOfBirth: getDateStringFromObject(data.dateOfBirth.get()),
                effectiveDate: getDateStringFromObject(data.coverageStartDate.get()),
                effectiveDatePart: data.part.get().toLowerCase(),
                lastName: data.lastName.get(),
                mbi: stripInvalidMbiChars(data.medicareNumber.get()),
                zipCodeOrCity: data.zipCodeOrCity.get(),
            },
            the.defaultHeader,
        );
    };

    const step3 = async (password = '', challengeQuestion = '', challengeAnswer = '') => {
        allow.aString(password, is.not.empty).oneOf(challengeQuestion, the.secretQuestions.English).aString(challengeAnswer, is.not.empty);
        data.password.set(password);
        data.secretAnswer.set(challengeAnswer);
        data.secretQuestion.set(challengeQuestion);
        return await axios.call(
            the.method.post,
            '/account/api/unlock-account/step/3',
            {
                challengeQuestionAndAnswers: [{
                    answer: data.secretAnswer.get(),
                    question: data.secretQuestion.get(),
                }],
                dateOfBirth: getDateStringFromObject(data.dateOfBirth.get()),
                effectiveDate: getDateStringFromObject(data.coverageStartDate.get()),
                effectiveDatePart: data.part.get().toLowerCase(),
                lastName: data.lastName.get(),
                mbi: stripInvalidMbiChars(data.medicareNumber.get()),
                password: data.password.get(),
                zipCodeOrCity: data.zipCodeOrCity.get(),
            },
            the.defaultHeader,
        );
    };

    return {
        step1,
        step2,
        step3,
    };
}
